<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <div class="mb-4">
                <div class="title">สวัสดี {{ $personName(user) }}</div>
                <div class="body-2 grey--text text--darken-1">เลือกเมนูที่ต้องการใช้งาน</div>
            </div>

            <v-row>
                <v-col
                    v-for="card in cards"
                    :key="card.routeName"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <!-- A locked card is a page that is deployed but not open to
                         this role yet. It stays on the page, greyed, so the change
                         is announced where the choice is made instead of in a
                         banner nobody reads twice. -->
                    <v-card
                        class="fill-height"
                        :disabled="card.locked"
                        :outlined="card.locked"
                        :elevation="card.locked ? 0 : 3"
                        @click="open(card)"
                    >
                        <v-card-text class="pb-2">
                            <v-icon
                                size="44"
                                :color="cardColor(card)"
                            >{{ card.icon }}</v-icon>

                            <div class="mt-2 subtitle-1 font-weight-medium black--text">
                                <v-badge :value="card.routeName === 'bookingDate' && proposalBadge > 0"
                                         :content="proposalBadge" color="red" inline>
                                    {{ card.title }}
                                </v-badge>
                            </div>
                            <div class="body-2 grey--text text--darken-1">
                                {{ card.desc }}
                            </div>
                            <div v-if="card.routeName === 'bookingDate' && proposalBadge > 0" class="body-2 red--text">
                                มีคำขอรอยืนยัน {{ proposalBadge }} รายการ
                            </div>
                        </v-card-text>

                        <v-card-text class="pt-0" v-if="card.locked || card.wasCalled">
                            <v-chip
                                v-if="card.locked"
                                x-small
                                color="amber darken-2"
                                dark
                                class="mr-1"
                            >ทดสอบ</v-chip>
                            <v-chip
                                v-if="card.wasCalled"
                                x-small
                                outlined
                                color="grey darken-1"
                            >เดิมชื่อ "{{ card.wasCalled }}"</v-chip>

                            <div v-if="card.locked" class="caption grey--text text--darken-1 mt-1">
                                อยู่ระหว่างทดสอบ ยังไม่เปิดใช้งาน
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>
<script>
import mainMenu from '@/components/mainMenu'
// The same table mainMenu.vue draws its menu from, so the cards and the menu can
// never offer a different set of pages.
import MR from '@/components/menuRoutes'

export default {
    components: {
        mainMenu
    },
    computed: {
        // Resolved exactly as mainMenu.vue resolves them -- see the comment there.
        user() {
            return this.$store.state.user || sessionStorage.user
        },
        userRole() {
            return this.$store.state.status || sessionStorage.status
        },
        proposalBadge () {
            return this.$store.getters.proposalBadge
        },
        // หน้าแรก is dropped: this is หน้าแรก.
        cards() {
            const role = this.userRole
            return MR.pagesForRole(role)
                .filter(page => page.routeName !== 'index')
                .map(page => Object.assign({}, page, {
                    locked: !MR.canOpen(page, role)
                }))
        }
    },
    methods: {
        // Colour answers one question only: can this role open the page? Orange
        // is every card you may click, grey is the one you may not. Ranking the
        // openable cards by colour as well made five usable cards on a delivery
        // login read as disabled, because grey was already carrying "locked".
        cardColor(card) {
            return card.locked ? 'grey lighten-1' : 'orange accent-3'
        },
        open(card) {
            // A locked card sets `disabled` on v-card, so this never fires for one.
            // router.js refuses the route anyway if it somehow does.
            this.$router.push({ name: card.routeName }).catch(err => {
                if (err.name !== 'NavigationDuplicated') throw err
            })
        }
    }
}
</script>
